module.exports = __webpack_public_path__ + "img/down-arrow.8b6c3291.svg";